function getInstanceFromElement(element, Constructor) {
  if (!element || !element.__base__ || !element.__base__.has(Constructor)) {
    return null;
  }
  return element.__base__.get(Constructor);
}
export {
  getInstanceFromElement as default
};
//# sourceMappingURL=getInstanceFromElement.js.map
